import useGame from "@hooks/useGame";
import { hexRGBA, media, pxToRem } from "src/styles/styleUtils";
import styled from "styled-components";
import LockSVG from "./svgs/lock.svg";

const OverlayContainer = styled.div`
  margin: 0 1rem;
  position: absolute;
  width: 100%;
  height: calc(100% + 2rem);
  top: -1rem;
  left: -1rem;
  background: ${({ theme }) =>
    `linear-gradient(-90deg, ${hexRGBA(theme.grey_700, 0.7)} 0%, rgba(0,0,0,0.75) 100%)`};
  border-radius: ${pxToRem(6)};
  color: white;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  h2 {
    margin: 0;
    text-align: center;
    line-height: 1.5;
  }

  ${media.mobile} {
    justify-content: flex-start;
    padding: 9rem 0.5rem;

    h2 {
      max-width: 70%;
      font-size: ${pxToRem(16)};
    }

    svg {
      width: ${pxToRem(14)};
      height: ${pxToRem(14)};
    }
  }
`;

function PrePicksOverlay() {
  const { data: game } = useGame();

  const now = Date.now();
  const startTime = game?.rounds?.[0]?.starts_at;
  const shouldRender = startTime > now ?? true;
  /**
   * Format: Monday, August 30, 2021
   */
  const getLocaleString = (iso?: number): string =>
    new Date(iso || now).toLocaleString([], {
      weekday: "long",
      day: "numeric",
      month: "long",
      year: "numeric",
    });

  return shouldRender ? (
    <OverlayContainer>
      <h2>Come back when picks open to select your playoffs drivers!</h2>
      <h2>
        <LockSVG width="21" height="21" alt="Lock icon" /> Opens {getLocaleString(startTime)}
      </h2>
    </OverlayContainer>
  ) : null;
}

export default PrePicksOverlay;
